<div class="row">
	<h2 class="col title">{{ 'hardwareScan.title' | translate }}</h2>
</div>
<div class="row">
 	<div class="col button-row">
		<vtr-material-button
			linkId="hwscan-quick-scan-btn"
			[label]="'hardwareScan.quickScan' | translate | uppercase"
			[isDisabled]="disableButtonScan"
			[tooltipText] ="'hardwareScan.reminderTimeRetrieveHardwareInformation' | translate"
			(buttonClick)="onQuickScan()"
			heightSize="lg">
		</vtr-material-button>
		<vtr-ui-hyperlink-button
			linkId="hwscan-custom-scan-btn"
			linkRole="button"
			class="hyperlink-container"
			hyperlinkStyle="xs-white"
			[isDisabled]="disableButtonScan"
			[label]="'hardwareScan.customize.name' | translate"
			[tooltipText]="'hardwareScan.reminderTimeRetrieveHardwareInformation' | translate"
			[upperCaseLabel]="true"
			(hyperlinkClick)="onAnchor()">
		</vtr-ui-hyperlink-button>
	</div>
</div>
